'use strict';

// Imports
var carouselUtils = require('../utils/carouselUtils');

module.exports = {
    /**
     * Initialize a slick carousel with the .hom-js-carousel-recommendations class content
     */
    initCarousel: function () {
        var carousels = $('.hom-js-carousel-recommendations');

        if (carousels.length) {
            carousels.each(function () {
                carouselUtils.createRecommendationsCarousel($(this));
            });
        }
    }
};
